import React, { useState, useEffect } from 'react';
import axios from 'axios'; // Assuming you're using axios for API calls
import ExceptionsList from './ExceptionsList';
import { fetchOrderActivities, fetchOrderExceptiosn } from '../../api/OrdersApi';
import ActivitiesList from './ActivitiesList';
import OrderFiledActivities from './OrderFiledActivities';
import { randomNumber } from '../../common/Common';
import { Col, Row , Typography} from 'antd';
import { Text } from '../../common/UIComponents';


const OrderActivities = ({ currentOrder, currentOrg, isMilitaryTime, fromIndividualScreen, activeKey = '' }) => {
  const [activities, setActivities] = useState([]);

  useEffect(() => {
    const fetchActivities = async () => {
      try {
        if (currentOrder.id) {
          const response = await fetchOrderActivities(currentOrder.id);
          if(response.success){
            const data = response.data || [];
            const fineTunedActivities = data.map(rec=> ({
                ...rec,
                id: rec.id ? rec.id : randomNumber(),
              }))
            setActivities(fineTunedActivities || []);
          }
        }
      } catch (error) {
        console.error('Error fetching exceptions:', error);
      }
    };
    if(activeKey === 'activities' && currentOrder?.id){
      fetchActivities();
    }
    
  }, [activeKey]);


  const renderExpandedRow = (record) => {
    const auditLogData = Array.isArray(record?.audit_log) ? record.audit_log.map(rec => ({ ...rec, id: randomNumber() })) : [];
    return auditLogData.length > 0 ? (
      <Row>
        <Col span={ 8 } className="padding10">
          <h3>Audit</h3>
          <OrderFiledActivities data={ auditLogData } pagination={ { position: 'none' } } />
        </Col>
      </Row>
    ) :
      (
        <Row>
          <Text className="textCenter">No Audit Log Found</Text>
        </Row>
      )
      ;
  };

  // const timeZoneId = currentOrder.wh_location ? currentOrder.wh_location.timeZoneId : '';
 

  return (
    <div>
      
      <ActivitiesList
        // rowClassName={(record) => record?.description ?
        //   _.includes(record.description.toLowerCase(), "complete")
        //     ? "bgd-color-green"
        //     : _.includes(record.description.toLowerCase(), "fail")
        //       ? "bgd-color-red"
        //       : null : null
        // }
        isMilitaryTime={isMilitaryTime}
        data={activities}
        size="small"
        pagination={{ position: "none" }}
        timeZone={currentOrder.timeZoneId}
        timeZoneName={currentOrder.tz_short_name}
        expandedRowRender={renderExpandedRow}
        scroll={{
          y: fromIndividualScreen
            ? "calc(80vh - 230px)"
            : "calc(90vh - 150px)",
        }}
      />
    </div>
  );
};

export default OrderActivities;
